import { render, staticRenderFns } from "./index.vue?vue&type=template&id=46091fc2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46091fc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46091fc2')) {
      api.createRecord('46091fc2', component.options)
    } else {
      api.reload('46091fc2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=46091fc2&scoped=true", function () {
      api.rerender('46091fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/seckill/index.vue"
export default component.exports